import React from "react";
import { formatDate } from "devextreme/localization";
import { ContactSkeleton } from "./HouseholdSkeletons";
import { HouseholdContact as Contact, Household } from "@/types/types";

type ContactProps = {
  isLoading: boolean;
  isRefetching: boolean;
  contact: Contact | null | undefined;
  isPrimary?: boolean;
};

const HouseholdContact: React.FC<ContactProps> = ({
  isLoading,
  isRefetching,
  contact,
  isPrimary = false,
}) => {
  return (
    <div className="flex flex-1 flex-col gap-4">
      {isLoading || isRefetching ? (
        <ContactSkeleton />
      ) : (
        <>
          <h2 className="text-lg font-medium">
            {isPrimary ? "Primary Contact" : "Secondary Contact"}
          </h2>
          <div
            className={`flex flex-wrap justify-between gap-6 rounded-md bg-white p-6 shadow-light`}
          >
            <div className={`flex w-[45%] flex-col gap-2`}>
              <span className="font-medium">Legal Name</span>
              <span>{contact?.legalName}</span>
            </div>
            <div className={`flex w-[45%] flex-col gap-2`}>
              <span className="font-medium">Preferred Name</span>
              <span>{contact?.preferredFullName}</span>
            </div>
            <div className={`flex w-[45%] flex-col gap-2`}>
              <span className="font-medium">Birth Date</span>
              <span>
                {contact?.birthDate
                  ? formatDate(new Date(contact?.birthDate?.toString()), "MM/dd/yyyy")
                  : ""}
              </span>
            </div>
            <div className={`flex w-[45%] flex-col gap-2`}>
              <span className="font-medium">Salutation</span>
              <span>{contact?.salutation}</span>
            </div>
          </div>
          {!contact?.birthDate && (
            <span className="text-sm text-danger">
              Please add {isPrimary ? "primary" : "secondary"} contact birth date to access
              additional functionalities. Thank you
            </span>
          )}
        </>
      )}
    </div>
  );
};

export const NoContactBirthDateMessage = ({
  household,
}: {
  household: Household | Partial<Household> | undefined;
}) => {
  const isPrimary = !household?.primaryContact?.birthDate;

  return (
    <span className="text-sm text-danger">
      Please add {isPrimary ? "primary" : "secondary"} contact birth date to access additional
      functionalities. Thank you.
    </span>
  );
};

export default HouseholdContact;
